/**
 * This file concerns itself only with the desktop nav
 */

function checkPeekMode() {
    this.oldScroll = this.oldScroll || this.scrollY;
    const nav = document.querySelector('.js-top-nav');
    const banner = document.querySelector('.site-banner--nav-wrapper');
    if (!nav) {
        return;
    }
    if (window.scrollY > nav.offsetHeight + 50) {
        nav.classList.add('top-nav--shrunk');
    } else {
        nav.classList.remove('top-nav--shrunk');
    }
    if (this.oldScroll < this.scrollY && window.scrollY > nav.offsetHeight + 50) {
        nav.classList.add('top-nav--hiding');
        if (banner) {
            banner.classList.add('site-banner--hiding');
        }
    } else {
        nav.classList.remove('top-nav--hiding');
        if (banner) {
            banner.classList.remove('site-banner--hiding');
        }
    }
    this.oldScroll = this.scrollY;
}

document.addEventListener('DOMContentLoaded', checkPeekMode);
window.addEventListener('scroll', checkPeekMode, global.quietmark.supportsPassive ? { passive: true } : false);
